import type { GeneratedQuizDto, QuizKitCopy } from '@peach/types/quizzes/generated-quiz.dto.js';
import type { CreateQuizBody, UpdateQuizBody } from '@peach/types/quizzes/quiz.dto.js';
import type { EditableQuiz } from '@/components/builder/QuizFields';

// Ids are minted here and never leave: the generator makes none, and the
// entity only needs them unique within one quiz.
const withIds = (questions: EditableQuiz['questions']) =>
  questions.map((question, index) => ({
    id: `q${index + 1}`,
    text: question.text,
    options: question.options.map((option, position) => ({
      id: `o${position + 1}`,
      label: option.label,
      isCorrect: option.isCorrect,
    })),
  }));

/** The quiz carries what it was written from, and it is stored with it so a later Swap reads the same. */
export function toCreateBody(quiz: GeneratedQuizDto): CreateQuizBody {
  return {
    title: quiz.title,
    kit: quiz.kit,
    brief: quiz.brief,
    audience: quiz.audience,
    taught: quiz.taught,
    voice: quiz.voice,
    generationId: quiz.generationId,
    questions: withIds(quiz.questions),
  };
}

/**
 * The edit screen's draft as `PATCH /quizzes/:id` takes it; ids are re-minted, so an
 * edit is a whole new list. `kit` travels only for a quiz that already had one.
 */
export function toUpdateBody(quiz: EditableQuiz, kit?: QuizKitCopy): UpdateQuizBody {
  return { title: quiz.title, questions: withIds(quiz.questions), ...(kit && { kit }) };
}
